module.exports = __webpack_public_path__ + "img/laboratorio5_4-3_3072.79b43d44.webp";